module.exports = __webpack_public_path__ + "static/media/news.5145864f.svg";